/* import plansApi from "../../api/plans" */
import utilsApi from "../../api/utils"

// general state for the eCommerce
const state = {
  plans: [],
  fetched: false,
  error: false,
  dataShape: [],
  extraInfo: {},
}

const getters = {
  plans: state => state.plans,
  plans_fetched: state => state.fetched,
  plansError: state => state.error,
  plans_dataShape: state => state.dataShape,
  plans_extraInfo: state => state.extraInfo,
}
const actions = {
  async DELETE_plans({ commit }, plan) {
    let apiResponse = await utilsApi.deleteObject("plans", plan)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PLANS_SETTING", apiResponse)
    } else {
      commit("PLANS_ERROR")
    }
  },
  async CREATE_plans({ commit }, plan) {
    let apiResponse = await utilsApi.createObject("plans", plan)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PLANS_SETTING", apiResponse)
    } else {
      commit("PLANS_ERROR")
    }
  },
  async SAVE_plans({ commit }, plan) {
    let apiResponse = await utilsApi.saveObject("plans", plan)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PLANS_SETTING", apiResponse)
    } else {
      commit("PLANS_ERROR")
    }
  },
  async FETCH_plans({ commit }) {
    let apiResponse = await utilsApi.getObjects("plans")
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PLANS_SETTING", apiResponse)
      return true
    } else {
      commit("PLANS_ERROR")
      return false
    }
  },
}
const mutations = {
  PLANS_SETTING: (state, { plans, dataShape, extraInfo }) => {
    state.plans = plans
    state.dataShape = dataShape
    state.extraInfo = extraInfo
    state.fetched = true
    state.error = false
  },
  PLANS_ERROR: state => {
    state.plans = null
    state.fetched = true
    state.error = false
    state.dataShape = []
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
